export default "__VITE_ASSET__ohaBH_lT__"